import type { UseQueryResult } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'

import type { getControllerOptions } from '@/features/controller/endpoints/controllers'
import {
  GET_CONTROLLER_BY_EQUIPMENT_NUMBER_API,
  getControllerByEquipmentNumber,
} from '@/features/controller/endpoints/controllers'
import type { ControllerDescription } from '@/features/controller/types'
import { retryOnNonUserError } from '@/features/controller/utils/retryOnNonUserError'
import type { UseQueryOptions } from '@/types/queries'

export type UseControllerByEquipmentNumberQueryResult = Omit<UseQueryResult, 'data'> & {
  controllerDescription: ControllerDescription | null
}

export function useControllerByEquipmentNumberQuery(
  controllerEquipmentNumber: number,
  options?: UseQueryOptions<ControllerDescription | null> & { getControllerOptions?: getControllerOptions },
): UseControllerByEquipmentNumberQueryResult {
  const { data, ...queryResult } = useQuery<ControllerDescription | null>({
    ...options,
    retry: retryOnNonUserError,
    queryFn: () => getControllerByEquipmentNumber(controllerEquipmentNumber, options?.getControllerOptions),
    queryKey: [GET_CONTROLLER_BY_EQUIPMENT_NUMBER_API, controllerEquipmentNumber],
  })

  return {
    ...queryResult,
    controllerDescription: data || null,
  }
}
